// extracted by mini-css-extract-plugin
module.exports = {"tableAnswerDisplay":"styles_tableAnswerDisplay__3JG97","sumDisplay":"styles_sumDisplay__Z9kLJ typography_defaultText__3yE-Q"};